/** Route state with which the sales invoices list opens its web form: the phone's «صدور» (2026-10-17). */
export const OPEN_NEW_INVOICE_STATE = {openInvoice: true}

export const wantsNewInvoice = (state: unknown): boolean =>
  typeof state === 'object' &&
  state !== null &&
  (state as {openInvoice?: unknown}).openInvoice === true
